import { api } from './client';

export interface ImportacaoXmlResultado {
  sucesso: boolean;
  acao: string;
  chave?: string | null;
  numero?: number | null;
  serie?: number | null;
  modelo?: string | null;
  emitente_id?: number | null;
  documento_id?: number | null;
  status?: string | null;
  mensagem?: string | null;
  arquivo?: string | null;
  pessoas_criadas?: number;
  produtos_criados?: number;
  itens?: number;
}

export interface ImportacaoXmlResumo {
  dry_run: boolean;
  total_arquivos: number;
  sucesso: number;
  erros: number;
  criados: number;
  atualizados: number;
  pessoas_criadas: number;
  produtos_criados: number;
  resultados: ImportacaoXmlResultado[];
}

export async function importarXmlUpload(files: File[], dryRun: boolean): Promise<ImportacaoXmlResumo> {
  const form = new FormData();
  files.forEach((file) => form.append('files', file));
  const { data } = await api.post<ImportacaoXmlResumo>('/importacoes/xml', form, {
    params: { dry_run: dryRun ? 1 : 0 },
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export const importarNFeXmlUpload = importarXmlUpload;

export async function importarXmlPasta(payload: {
  pasta: string;
  dry_run: boolean;
  limite?: number;
}): Promise<ImportacaoXmlResumo> {
  const { data } = await api.post<ImportacaoXmlResumo>('/importacoes/xml/pasta', payload);
  return data;
}
